"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assignment = void 0;
class Assignment {
    constructor(user, results) {
        this.timestamp = Date.now();
        this.user = user;
        this.results = results;
    }
    canonicalize() {
        var _a, _b, _c;
        let canonical = `${(_a = this.user.user_id) === null || _a === void 0 ? void 0 : _a.trim()} ${(_b = this.user.device_id) === null || _b === void 0 ? void 0 : _b.trim()} `;
        for (const key of Object.keys(this.results).sort()) {
            const value = this.results[key];
            canonical += key.trim() + ' ' + ((_c = value === null || value === void 0 ? void 0 : value.value) === null || _c === void 0 ? void 0 : _c.trim()) + ' ';
        }
        return canonical;
    }
}
exports.Assignment = Assignment;
